// src/services/bulkOrderService.ts
import { collection, addDoc } from 'firebase/firestore';
import { db } from '../config/firebase';

export interface BulkOrderData {
  name: string;
  email: string;
  phone: string;
  company: string;
  requirements: string;
  estimatedQuantity: string;
  timeline: string;
  message: string;
  status: 'pending' | 'reviewed' | 'contacted' | 'completed';
  createdAt: Date;
}

class BulkOrderService {
  private bulkOrdersCollection = collection(db, 'bulkOrders');

  async submitBulkOrder(data: Omit<BulkOrderData, 'status' | 'createdAt'>): Promise<string> {
    try {
      const bulkOrderData: BulkOrderData = {
        ...data,
        status: 'pending',
        createdAt: new Date(),
      };

      const docRef = await addDoc(this.bulkOrdersCollection, bulkOrderData);
      return docRef.id;
    } catch (error) {
      console.error('Error submitting bulk order:', error);
      throw error;
    }
  }
}

export const bulkOrderService = new BulkOrderService();